import React from 'react';
import './CSS/Careers.css';

function Careers() {
  const jobList = [
    {
      title: 'Veterinario/a Generalista',
      description: 'Buscamos un Veterinario/a especializado en medicina felina y que también se pueda hacer cargo de pacientes caninos cuando sea necesario. El horario de consulta sería de 11:00 a 20:00 de lunes a viernes horario continuo, realizandose las cirugías a las 9:00 si hubiese, y de 11:00 a 13:30 los sábados, domingos cerrados. El sueldo se decidirá en base a la formación y la clínica se hará cargo de gastos de formación adicionales.',
      skills: ['Licenciatura en Veterinaria', 'Fomentar el buen ambiente', 'Capacidad de adaptación', 'Buen trato con el cliente'],
    }
  ];

  return (
    <section id="careers" className="careers-section">
      <h1>Únete a nuestro equipo</h1>
      <div className="careers-container">
        {jobList.map((job, index) => (
          <div key={index} className="job-card">
            <h2>{job.title}</h2>
            <p>{job.description}</p>
            <h3>Aptitudes requeridas:</h3>
            <ul>
              {job.skills.map((skill, skillIndex) => (
                <li key={skillIndex}>✓ {skill}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Careers;